import Icon from '../components/Icon.vue'

Icon.register({
  directions: {
    width: 512,
    height: 512,
    paths: [
      {
        d: 'M502.6 233.3c12.5 12.5 12.5 32.8 0 45.4l-223.9 223.9c-12.5 12.5-32.8 12.5-45.4 0l-223.9-223.9c-12.5-12.5-12.5-32.8 0-45.4l223.9-223.9c12.5-12.5 32.8-12.5 45.4 0zM401.6 245.9c3.4-3.2 3.4-8.6 0-11.8l-84.2-77.7c-5.1-4.7-13.4-1.1-13.4 5.9v53.7h-112c-17.7 0-32 14.3-32 32v80c0 4.4 3.6 8 8 8h32c4.4 0 8-3.6 8-8v-64h96v53.7c0 7 8.3 10.6 13.4 5.9z'
      }
    ]
  }
})
